/**
 * Get only the given keys from the given object
 *
 * @param   {object} object
 * @param   {array} keys
 * @returns {object}
 */
function objOnly(object, keys) {
    var newObject = {};
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (object.hasOwnProperty(key)) {
            newObject[key] = object[key];
        }
    }
    return newObject;
}

export { objOnly as default };
